// Check if GSAP and ScrollTrigger are available
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);
    
    // Check if any imageScroll elements exist before running animations
    const imageScrollElements = document.querySelectorAll('.imageScroll');
    
    // Only run if we have imageScroll elements on this page
    if (imageScrollElements.length > 0) {
        
        // Wait for DOM to be fully ready
        document.addEventListener('DOMContentLoaded', function() {
            
            gsap.utils.toArray(".imageScroll").forEach((image) => {
                // Additional check that element still exists
                if (image) {
                    // Set initial state
                    gsap.set(image, { scale: 1 });

                    // Create scroll-triggered scale animation
                    gsap.to(image, {
                        scale: 1.1, 
                        ease: "none",
                        scrollTrigger: {
                            trigger: image,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: 1,
                        },
                    });
                }
            });
            
            // Optional: Refresh ScrollTrigger after setup
            ScrollTrigger.refresh();
        });
        
    } else {
        // No imageScroll elements found - silently exit
        
    }
    
} else {
    // GSAP or ScrollTrigger not available
    console.warn('GSAP or ScrollTrigger not loaded - image scroll effects disabled');
}